import { render, staticRenderFns } from "./promo-sale-flash-banner.vue?vue&type=template&id=6d91ca6d&scoped=true&"
import script from "./promo-sale-flash-banner.vue?vue&type=script&lang=js&"
export * from "./promo-sale-flash-banner.vue?vue&type=script&lang=js&"
import style0 from "./promo-sale-flash-banner.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./promo-sale-flash-banner.vue?vue&type=style&index=1&id=6d91ca6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d91ca6d",
  null
  
)

export default component.exports